/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ApiReorderChannelsInputFromJSON(json) {
    return ApiReorderChannelsInputFromJSONTyped(json, false);
}
export function ApiReorderChannelsInputFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'channelId': !exists(json, 'channelId') ? undefined : json['channelId'],
        'priority': !exists(json, 'priority') ? undefined : json['priority'],
    };
}
export function ApiReorderChannelsInputToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'channelId': value.channelId,
        'priority': value.priority,
    };
}
